import useUserGeoLocation from "@casino/legacyUi/form/FormPhoneNumber/hooks/useUserGeoLocation";
import { useMemo } from "react";
import emailSuggestionByCountry from "./emailSuggestionByCountry.json";

const defaultEmails = ["gmail.com", "yahoo.com", "hotmail.com"];

const useEmailSuggestion = () => {
  const { userGeoCountryCode } = useUserGeoLocation();

  const suggestedEmails = useMemo(
    () =>
      emailSuggestionByCountry.find(
        (country) => country.countryCode === userGeoCountryCode,
      ),
    [userGeoCountryCode],
  );

  const selectedEmails = suggestedEmails
    ? suggestedEmails.mails
    : defaultEmails;

  return selectedEmails;
};

export default useEmailSuggestion;
